/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { Form, Schema, Button, Modal, SelectPicker } from 'rsuite';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { ButtonFullBlue } from '../../../../components/Buttons/ButtonFullBlue/styles';

const { NumberType } = Schema.Types;

const modelo = Schema.Model({
  id_profissao: NumberType().isRequired('Profissao Obrigatória'),
});

function AdicionarManual({ exibir, fechar, salvar }) {
  const [camposInput, setCamposInput] = useState({});
  const [profissoes, setProfissoes] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [arquivo, setArquivo] = useState();

  useEffect(() => {
    const buscarBancos = async () => {
      try {
        const resposta = await api.get('/profissao');
        setProfissoes(resposta.data);
      } catch (e) {
        toast.error(e.message);
      }
    };

    buscarBancos();
  }, []);

  async function salvarConta() {
    setCarregando(true);
    await salvar({ arquivo, id_profissao: camposInput.id_profissao });
    setCamposInput({});
    setCarregando(false);
  }

  return (
    <Modal open={exibir} onClose={() => fechar()} size="xs">
      <Form
        fluid
        model={modelo}
        onChange={setCamposInput}
        formDefaultValue={camposInput}
        onSubmit={(erro) => erro && salvarConta()}
      >
        <Modal.Header>
          <Modal.Title>Adicionar Manual</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.ControlLabel>Profissao</Form.ControlLabel>
            <Form.Control
              name="id_profissao"
              accepter={SelectPicker}
              placeholder="Selecione"
              block
              data={profissoes.map((p) => {
                return {
                  label: p.profissao,
                  value: p.id,
                };
              })}
            />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>Manual</Form.ControlLabel>
            <Form.Control
              name="arquivo"
              type="file"
              accept=".pdf"
              onChange={async (_, evento) => {
                setArquivo(evento.target.files[0]);
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => fechar()} appearance="subtle">
            Cancelar
          </Button>
          <ButtonFullBlue
            type="submit"
            loading={carregando}
            appearance="primary"
          >
            Confirmar
          </ButtonFullBlue>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

AdicionarManual.propTypes = {
  exibir: PropTypes.bool.isRequired,
  fechar: PropTypes.func.isRequired,
  salvar: PropTypes.func.isRequired,
};

export default AdicionarManual;
